class ToggleDiscount extends HTMLElement {
  #selectors = {
    checkbox: '[type="checkbox"]',
  };

  connectedCallback() {
    this.checkbox = this.querySelector(this.#selectors.checkbox);

    this.#setupEventListeners();
  }

  #setupEventListeners() {
    this.checkbox?.addEventListener('change', this.#handleDiscountChange);
    Shopify.discount.onUpdated(this.#handleDiscountUpdated.bind(this));
  }

  #handleDiscountChange = event => {
    const code = event.target.name;
    const isChecked = event.target.checked;
    this.#loading(true);
    isChecked ? Shopify.discount.apply(code) : Shopify.discount.clear();
  };

  #handleDiscountUpdated() {
    this.#loading(false);
  }

  #loading(value) {
    if (value) {
      this.setAttribute('data-loading', '');
      this.checkbox.setAttribute('disabled', '');
    } else {
      this.checkbox.removeAttribute('disabled');
      this.removeAttribute('data-loading');
    }
  }
}

customElements.define('toggle-discount', ToggleDiscount);
